interface Props {
  values: number[];
  width?: number;
  height?: number;
  title?: string;
}

/**
 * A sparkline: the shape of the last hour, nothing else. No axis, no grid, one
 * stroke in the accent -- it sits inside a table cell beside the number it
 * belongs to, and the number is the fact; this is the trend.
 */
export function Spark({ values, width = 84, height = 22, title }: Props) {
  if (!values.length) return null;
  const max = Math.max(1, ...values);
  const step = values.length > 1 ? width / (values.length - 1) : width;
  const points = values
    .map((value, index) => `${(index * step).toFixed(1)},${(height - 2 - (value / max) * (height - 4)).toFixed(1)}`)
    .join(' ');
  return (
    <svg className="wt-spark" width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label={title}>
      {title && <title>{title}</title>}
      <polyline points={points} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
